import { Outlet } from 'react-router-dom'

import { Box, Spinner } from '@factorialco/deprecated-design-system'
import { PerformanceGoalsRootPageDocument } from 'generated/resources/graphql'

import AuthorizeUser from 'modules/core/components/AuthorizeUser'
import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useQuery } from 'modules/core/hooks/useQuery'

import CollectionsBootstrap from 'modules/performance_goals/lib/CollectionsBootstrap'

const RootPage = () => {
  const { company } = useCurrentSession()
  const { data, loading } = useQuery(PerformanceGoalsRootPageDocument, {
    variables: {
      companyId: company.id,
    },
  })
  const hasGoalsRevampFeature =
    data?.features.featuresConnection.nodes.some(
      (feature) => feature.name === 'dev_performance_goals_revamp'
    ) ?? false

  if (loading) {
    return (
      <Box width="full" alignItems="center" height="full" justifyContent="center">
        <Spinner />
      </Box>
    )
  }

  return (
    <CollectionsBootstrap>
      <AuthorizeUser authorizeFn={() => hasGoalsRevampFeature}>
        <Outlet />
      </AuthorizeUser>
    </CollectionsBootstrap>
  )
}

export default RootPage
